import useMedia from 'use-media';

export const useLessThen991 = (isDesktop: boolean) => {
  return useMedia({ maxWidth: '991px' }) || !isDesktop;
};

export const useLessThen640 = () => {
  return useMedia({ maxWidth: '640px' });
};
